import { render, staticRenderFns } from "./floor-multi-sector.vue?vue&type=template&id=2f88ff2c&scoped=true"
import script from "./floor-multi-sector.vue?vue&type=script&lang=js"
export * from "./floor-multi-sector.vue?vue&type=script&lang=js"
import style0 from "./floor-multi-sector.vue?vue&type=style&index=0&id=2f88ff2c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f88ff2c",
  null
  
)

export default component.exports